import ChooseFilterType from './ChooseFilterType'

export default ChooseFilterType
